module.exports = "../../app/cells/pages/landing_playground/index/forum_cell.rb";